/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes, provideRouter, withNavigationErrorHandler } from '@angular/router';
import { AccidentListComponent } from "./accidentList/accidentList.component";
import { AuthGuard } from './core/auth/auth-guard';
import { HomeComponent } from "./home/home.component";
import { DriverDetailComponent } from "./driver-detail/driver-detail.component";
import { DriverSearchAddComponent } from "./admin/driver-search-add/driver-search-add.component";
import { SitesComponent } from "./admin/sites/sites.component";
import { TrainingComponent } from "./admin/training/training.component";
import { AuthResolver } from "./services/auth.resolver";
import { EndorsementsComponent } from "./admin/endorsements/endorsements.component";
import { GovernmentEndorsementsComponent } from "./admin/endorsements-gov/endorsements-gov.component";
import { DrivingLevelComponent } from "./admin/driving-level/driving-level.component";
import { SiteDetailComponent } from "./admin/site-detail/site-detail.component";
import { ViewReportComponent } from "./reports/view-report/view-report.component";
import { AccidentDetailComponent } from "./accident-detail/accident-detail.component";
import { PersonDetailComponent } from "./person-detail/person-detail.component";
import { RegionsComponent } from './admin/regions/regions.component';
import { LicenseTypesComponent } from './admin/license-type/license-types.component';
import { LocationsComponent } from './admin/locations/locations.component';
import { LocationTypeComponent } from './admin/location-type/location-type.component';
import { ViolationDefinitionComponent } from "./admin/violation-definition/violation-definition.component";
import { PageNoFoundComponent } from "./page-no-found/page-no-found.component";
import { AccidentClassificationComponent } from "./admin/accident-classification/accident-classification.component";
import { AccidentCausationComponent } from "./admin/accident-causation/accident-causation.component";
import { AccidentCrashObjectComponent } from "./admin/accident-crash-object/accident-crash-object.component";
import { VehicleDirectionComponent } from "./admin/vehicle-direction/vehicle-direction.component";
import { AccidentPersonTypeComponent } from "./admin/accident-person-type/accident-person-type.component";
import { InjuryClassificationComponent } from "./admin/injury-classification/injury-classification.component";



const routes: Routes = [
  {path: '', component: HomeComponent, canActivate: [AuthGuard]},
  {path: 'admin/accident-causation', component: AccidentCausationComponent, canActivate: [AuthGuard]},
  {path: 'accidentList', component: AccidentListComponent, canActivate: [AuthGuard]},
  {path: 'accidentDetail', component: AccidentDetailComponent, canActivate: [AuthGuard]},
  {path: 'accidentDetail/person/:personId', component: AccidentDetailComponent, canActivate: [AuthGuard]},
  {path: 'accidentDetail/person/:personId/accident/:accidentId', component: AccidentDetailComponent, canActivate: [AuthGuard]},
  {path: 'accidentDetail', component: AccidentDetailComponent, canActivate: [AuthGuard]},
  {path: 'driverDetail', component: DriverDetailComponent},
  {path: 'personDetail', component: PersonDetailComponent, canActivate: [AuthGuard]},
  {path: 'driverDetail/:id', component: DriverDetailComponent},
  {path: 'driverSearchAdd', component: DriverSearchAddComponent, canActivate: [AuthGuard]},
  {path: 'admin/licenseTypes', component: LicenseTypesComponent, canActivate: [AuthGuard]},
  {path: 'admin/locations', component: LocationsComponent, canActivate: [AuthGuard]},
  {path: 'admin/location-type', component: LocationTypeComponent, canActivate: [AuthGuard]},
  {path: 'admin/regions', component: RegionsComponent, canActivate: [AuthGuard]},
  {path: 'admin/sites', component: SitesComponent, canActivate: [AuthGuard]},
  {path: 'admin/accident-classification', component: AccidentClassificationComponent, canActivate: [AuthGuard]},
  {path: 'admin/accident-crash-object', component: AccidentCrashObjectComponent, canActivate: [AuthGuard]},
  {path: 'admin/vehicle-direction', component: VehicleDirectionComponent, canActivate: [AuthGuard]},
  {path: 'admin/accident-person-type', component: AccidentPersonTypeComponent, canActivate: [AuthGuard]},
  {path: 'admin/injury-classification', component: InjuryClassificationComponent, canActivate: [AuthGuard]},
  {path: 'admin/training', component: TrainingComponent, canActivate: [AuthGuard]},
  {path: 'admin/endorsements', component: EndorsementsComponent, canActivate: [AuthGuard]},
  {path: 'admin/endorsements-gov', component: GovernmentEndorsementsComponent, canActivate: [AuthGuard]},
  {path: 'admin/driverlevels', component: DrivingLevelComponent, canActivate: [AuthGuard]},
  {path: 'admin/siteDetail/:id', component: SiteDetailComponent, canActivate: [AuthGuard]},
  {path: 'admin/violation-definition', component: ViolationDefinitionComponent, canActivate: [AuthGuard]},
  {path: 'reports/viewreport', component: ViewReportComponent, canActivate: [AuthGuard]},
  {path: 'error', component: PageNoFoundComponent, canActivate: [AuthGuard]}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule {
}
